import React, { useEffect, useState } from "react";
import {
  Card,
  Table,
  Button,
  message,
  Spin,
  Image,
  Tooltip,
  Badge,
  Modal,
  Form,
  Input,
  Upload,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  UploadOutlined,
  ExclamationCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  addBanner,
  bannerPublishUpdate,
  getAllBanners,
  updateBanner,
  updateBannerStatus,
} from "../../../api/AdminRequest";
import CropperUploder from "../../imageUploader/CropperUploder";

const { confirm } = Modal;

const Banner = () => {
  const [allBanners, setAllBanners] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [changedBanners, setChangedBanners] = useState([]);
  const [loader, setLoader] = useState(false);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingBanner, setEditingBanner] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [imgPre, setImgPre] = useState("");
  const [imageError, setImageError] = useState("");

  const [form] = Form.useForm();

  useEffect(() => {
    fetchBanners();
  }, []);

  const fetchBanners = async () => {
    try {
      setLoader(true);
      const { data } = await getAllBanners();
      if (data.success === true) {
        setAllBanners(data.allBanners);
      }
    } catch (error) {
      console.error("Failed to fetch banners:", error);
      message.error("Failed to load banners");
    } finally {
      setLoader(false);
    }
  };

  const toggleBannerPublishState = (id) => {
    setChangedBanners((prev) => {
      const index = prev.findIndex((b) => b.id === id);
      if (index > -1) {
        return prev.filter((b) => b.id !== id);
      } else {
        const banner = allBanners.find((b) => b._id === id);
        return [...prev, { id, publish: !banner.publish }];
      }
    });
  };

  const handleSaveChanges = async () => {
    try {
      const { data } = await bannerPublishUpdate(changedBanners);
      if (data.success) {
        const updatedBanners = allBanners.map((banner) => {
          const changedBanner = changedBanners.find((b) => b.id === banner._id);
          if (changedBanner) {
            return { ...banner, publish: changedBanner.publish };
          }
          return banner;
        });
        setAllBanners(updatedBanners);
        setChangedBanners([]);
        setIsEditMode(false);
        message.success("Changes saved successfully");
      }
    } catch (error) {
      console.error("Failed to save changes:", error);
      message.error("Failed to save changes");
    }
  };

  const handleDiscardChanges = () => {
    setChangedBanners([]);
    setIsEditMode(false);
  };

  const isBannerChanged = (banner) => {
    return changedBanners.some((b) => b.id === banner._id);
  };
  // ------------- EDIT MODAL CODE----------
  const showModal = (banner = null) => {
    setEditingBanner(banner);
    if (banner) {
      form.setFieldsValue({
        title: banner.title,
        subTitle: banner.subTitle,
        description: banner.description,
        // media: banner.media
        //   ? [
        //       {
        //         uid: "-1",
        //         name: "image.png",
        //         status: "done",
        //         url: banner.media,
        //       },
        //     ]
        //   : [],
      });
      setFileList(
        banner?.media
          ? [
              {
                uid: "-1",
                name: "image.png",
                status: banner?.media ? "done" : "",
                url: banner?.media,
              },
            ]
          : []
      );
    } else {
      form.resetFields();
    }
    setIsModalVisible(true);
  };

  const handleModalOk = async () => {
    try {
      const values = await form.validateFields();
      if (fileList.length === 0) {
        setImageError("Please upload an image");
        return;
      }

      setImageError(""); // Clear any previous error
      
      const formData = new FormData();
      formData.append("title", values.title);
      formData.append("subTitle", values.subTitle);
      formData.append("description", values.description);  
    if (fileList[0]?.originFileObj) {
        formData.append("media", fileList[0].originFileObj, "media");
      }
      let response;
      if (editingBanner) {
        response = await updateBanner(editingBanner._id, formData);
      } else {
        response = await addBanner(formData);
      }

      const { data } = response;
      if (data.success) {
        message.success(
          editingBanner
            ? "Banner updated successfully"
            : "Banner added successfully"
        );
        setIsModalVisible(false);
        fetchBanners(); // Refresh the banner list
      }
    } catch (error) {
      console.error("Failed to save banner:", error);
      message.error("Failed to save banner");
    }
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
    setEditingBanner(null);
    setFileList([])
    form.resetFields();
  };

  //   ---------- IMAGE------
  const handleDataFromChild = (data, base64Img) => {
    const imgSelected = [
      {
        uid: "-1",
        name: "image.png",
        status: data ? "done" : "",
        url: base64Img,
        thumbUrl: base64Img,
        originFileObj: data,
      },
    ];
    setFileList(imgSelected);
    setImgPre(base64Img);
  };
  const onChange = ({ fileList: newFileList }) => {
    if (newFileList[0]?.status) {
      newFileList[0].status = "done";
    }
    setFileList(newFileList);
    setImgPre(
      newFileList[0]?.originFileObj
        ? URL.createObjectURL(newFileList[0]?.originFileObj)
        : ""
    );
  };
  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  const uploderButton = (
    <div className="flex flex-col items-center justify-center w-[130px] h-[130px] border border-dashed border-[#A3BBFF] rounded-md">
      <PlusOutlined style={{ fontSize: "32px", color: "#A3BBFF" }} />
      <p className="mt-2 text-[18px] font-medium text-[#313131]">Upload</p>
    </div>
  );

  //   ----------------- DELETE FUNCTION----------
  const handleDeleteConfirm = (banner) => {
    confirm({
      title: "Are you sure you want to delete this banner?",
      icon: <ExclamationCircleOutlined />,
      content: "This action cannot be undone.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: async () => {
        try {
          const { data } = await updateBannerStatus(banner._id, {
            status: "delete",
          });
          if (data.success) {
            message.success("Banner deleted successfully");
            fetchBanners(); // Refresh the banner list
          }
        } catch (error) {
          console.error("Failed to delete banner:", error);
          message.error("Failed to delete banner");
        }
      },
    });
  };

  const columns = [
    {
      title: "Image",
      dataIndex: "media",
      key: "media",
      render: (media) => <Image width={60} height={60} src={media} />,
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (text) => text || "N/A",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text) => text || "N/A",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => {
        // if (!isEditMode) return null;
        const isChanged = isBannerChanged(record);
        const willBePublished = isChanged
          ? changedBanners.find((r) => r.id === record._id).publish
          : record.publish;
        return (
          <div className="flex gap-2">
            <Button
              onClick={() => toggleBannerPublishState(record._id)}
              type={willBePublished ? "primary" : "default"}
              disabled={!isEditMode}
            >
              {willBePublished
                ? isChanged
                  ? "Uploaded"
                  : "Published"
                : "Upload"}
            </Button>

            <Tooltip title="Edit">
              <Button
                icon={<EditOutlined />}
                className="bg-[#1955EB] text-white hover:border-[#1955EB] hover:bg-[#1945E0]"
                // onClick={() => showEditModal(record)}
                onClick={() => showModal(record)}
              />
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                icon={<DeleteOutlined />}
                className="bg-[#FF4545] text-white hover:border-[#FF4545] hover:bg-[#FF3535]"
                onClick={() => handleDeleteConfirm(record)}
              />
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const publishedBanners = allBanners.filter(
    (review) => review.publish !== isBannerChanged(review)
  );

  return (
    <Spin spinning={loader}>
      <div className="p-2">
        <div className="mb-2 flex justify-end">
          <Button
            className="px-8 py-2 text-[14px] h-10 font-medium text-white bg-[#1955EB] hover:border-[#1955EB] border-[1px] rounded-md hover:bg-white hover:text-[#1955EB]"
            onClick={() => showModal()}
          >
            Add Banner
          </Button>
        </div>

        <Card
          title={
            <div className="flex gap-2 items-center">
              <span>Live Banners</span>
              <span className="text-gray-500 text-sm">
                {publishedBanners.length} Banners
              </span>

              <button
                onClick={() => setIsEditMode(!isEditMode)}
                // onClick={handleDiscardChanges}
                className="text-[#1955EB] hover:text-blue-700 underline hover:no-underline font-medium focus:outline-none"
              >
                {isEditMode ? "Cancel" : "Change"}
              </button>
            </div>
          }
          className="w-full"
          style={{ maxWidth: "1150px", padding: "0" }}
        >
          <div className="h-full overflow-x-auto scrollbar-hide p-4">
            <div className="flex space-x-4 pb-4 h-full">
              {publishedBanners.map((banner) => (
                <div key={banner._id} className="flex flex-col gap-2">
                  {banner?.publish ? (
                    <Badge.Ribbon text="Live" color="green">
                      <Card className="flex-shrink-0 shadow-sm relative">
                        <Image width={300} height={200} src={banner.media} />
                      </Card>
                    </Badge.Ribbon>
                  ) : (
                    <Card className="flex-shrink-0 shadow-sm relative">
                      <Image width={300} height={200} src={banner.media} />
                    </Card>
                  )}
                  <div className="flex justify-between items-center">
                    <div>
                      <p className="font-bold text-sm">{banner.title}</p>
                      <p className="text-xs text-gray-500 truncate w-32">
                        {banner.description}
                      </p>
                    </div>
                    {isEditMode && (
                      <div className="flex gap-2 text-right">
                        <>
                          <EditOutlined  onClick={() => showModal(banner)}/>
                          <DeleteOutlined
                            onClick={() => toggleBannerPublishState(banner._id)}
                          />
                        </>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
          {isEditMode && (
            <div className="flex justify-end mt-4 space-x-2">
              <Button onClick={handleDiscardChanges}>Discard</Button>
              <Button type="primary" onClick={handleSaveChanges}>
                Save Changes
              </Button>
            </div>
          )}
        </Card>

        <div className="mt-6">
          <Table columns={columns} dataSource={allBanners} pagination={false} />
        </div>
      </div>
    
      <Modal
        title={editingBanner ? "Edit Banner" : "Add Banner"}
        visible={isModalVisible}
        onOk={handleModalOk}
        
        onCancel={handleModalCancel}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="title"
            label="Title"
            rules={[{ required: true, message: "Please input the title!" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
           name="subTitle" 
           label="Subtitle"
           rules={[{ required: true, message: "Please input the subTitle!" }]}
           
           >
            <Input />
          </Form.Item>
          <Form.Item 
          name="description"
           label="Description"
           rules={[{ required: true, message: "Please input the Description!" }]}

           >
            <Input.TextArea />
          </Form.Item>
          <div>
          <label className="block mb-2">Image</label>
            {fileList?.length !== 0 ? (
              <Upload
                action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                listType="picture-card"
                fileList={fileList}
                onChange={onChange}
                onPreview={onPreview}
              >
                {fileList?.length < 1 && uploderButton}
              </Upload>
            ) : (
              <div className="w-full h-full">
                <CropperUploder
                  onDataFromChild={handleDataFromChild}
                  uploderButton={uploderButton}
                  identifier={"media"}
                />
              </div>
            )}
          {imageError && <div className="text-red-500 mt-2">{imageError}</div>}
          </div>
        </Form>
      </Modal>
    </Spin>
  );
};

export default Banner;
